var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCenterPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 744,
    height: 484,
    viewBox: "0 0 744 484",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E5EDFF",
    fillRule: "nonzero",
    d: "M0.5 0H742.5V87H0.5z",
    transform: "translate(.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6E2FB",
    fillRule: "nonzero",
    d: "M0.5 397H742.5V484H0.5z",
    transform: "translate(.5)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E5EDFF",
    fillRule: "nonzero",
    d: "M0 0H742V335H0z",
    transform: "translate(.5) translate(0 75)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6E2FB",
    fillRule: "nonzero",
    d: "M0 238.52H742V335H0z",
    transform: "translate(.5) translate(0 75)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F7FF",
    fillRule: "nonzero",
    d: "M546.455 238.52c0-96.208-77.954-174.2-174.116-174.2-96.161 0-174.115 77.992-174.115 174.2",
    transform: "translate(.5) translate(0 75)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D5D82",
    d: "M446.871 48.065c-2.198-4.301-7.946-7.82-12.774-7.82H306.295c-4.828 0-10.576 3.52-12.774 7.82l-26.5 51.864c-2.198 4.301-.046 7.82 4.782 7.82h196.785c4.828 0 6.98-3.52 4.783-7.82l-26.5-51.864z",
    transform: "translate(.5) translate(0 75)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7D6F3",
    d: "M262.513 101.84H479.715V292.601H262.513z",
    transform: "translate(.5) translate(0 75)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D5D82",
    d: "M338.889 218.198c0-2.213 1.79-4.007 4-4.007H397.5c2.209 0 4 1.793 4 4.007v75.066c0 2.213-1.79 4.007-4 4.007h-54.612c-2.21 0-4-1.793-4-4.007v-75.066zM280.73 142.761L318.687 142.761 318.687 185.678 280.73 185.678z",
    transform: "translate(.5) translate(0 75)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5C709C",
    d: "M280.73 159.828H318.68600000000004V168.61H280.73z",
    transform: "translate(.5) translate(0 75)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5C709C",
    d: "M318.686 190.068H280.73c-2.424 0-4.389-1.965-4.389-4.391v-42.918c0-2.426 1.965-4.392 4.39-4.392h37.956c2.424 0 4.389 1.966 4.389 4.392v42.918c0 2.426-1.966 4.391-4.39 4.391zm-33.567-8.782h29.178V147.15h-29.178v34.136z",
    transform: "translate(.5) translate(0 75)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D5D82",
    d: "M351.219 142.761L389.174 142.761 389.174 185.678 351.219 185.678z",
    transform: "translate(.5) translate(0 75)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5C709C",
    d: "M351.219 159.828H389.174V168.61H351.219z",
    transform: "translate(.5) translate(0 75)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5C709C",
    d: "M389.174 190.068h-37.955c-2.424 0-4.39-1.965-4.39-4.391v-42.918c0-2.426 1.966-4.392 4.39-4.392h37.955c2.425 0 4.39 1.966 4.39 4.392v42.918c0 2.426-1.965 4.391-4.39 4.391zm-33.566-8.782h29.177V147.15h-29.177v34.136z",
    transform: "translate(.5) translate(0 75)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D5D82",
    d: "M421.708 142.761L459.664 142.761 459.664 185.678 421.708 185.678z",
    transform: "translate(.5) translate(0 75)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5C709C",
    d: "M421.708 159.828L459.664 159.828 459.664 168.611 421.708 168.611z",
    transform: "translate(.5) translate(0 75)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5C709C",
    d: "M459.666 190.068h-37.957c-2.424 0-4.389-1.965-4.389-4.391v-42.918c0-2.426 1.965-4.392 4.39-4.392h37.956c2.424 0 4.389 1.966 4.389 4.392v42.918c0 2.426-1.965 4.391-4.39 4.391zm-33.567-8.782h29.177V147.15H426.1v34.136z",
    transform: "translate(.5) translate(0 75)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D5D82",
    d: "M280.73 203.09H318.68600000000004V246.007H280.73z",
    transform: "translate(.5) translate(0 75)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5C709C",
    d: "M280.73 220.158H318.68600000000004V228.94H280.73z",
    transform: "translate(.5) translate(0 75)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5C709C",
    d: "M318.686 250.4H280.73c-2.424 0-4.389-1.966-4.389-4.392V203.09c0-2.426 1.965-4.391 4.39-4.391h37.956c2.424 0 4.389 1.965 4.389 4.391v42.918c0 2.426-1.966 4.392-4.39 4.392zm-33.567-8.782h29.178v-34.136h-29.178v34.136z",
    transform: "translate(.5) translate(0 75)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D5D82",
    d: "M421.708 203.09L459.664 203.09 459.664 246.007 421.708 246.007z",
    transform: "translate(.5) translate(0 75)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5C709C",
    d: "M421.708 220.158L459.664 220.158 459.664 228.94 421.708 228.94z",
    transform: "translate(.5) translate(0 75)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5C709C",
    d: "M459.666 250.4h-37.957c-2.424 0-4.389-1.966-4.389-4.392V203.09c0-2.426 1.965-4.391 4.39-4.391h37.956c2.424 0 4.389 1.965 4.389 4.391v42.918c0 2.426-1.965 4.392-4.39 4.392zm-33.567-8.782h29.177v-34.136H426.1v34.136zM487.1 101.506c0-3.22-2.634-5.855-5.852-5.855H259.145c-3.219 0-5.852 2.635-5.852 5.855v7.127c0 3.22 2.634 5.854 5.852 5.854h222.102c3.219 0 5.852-2.635 5.852-5.854v-7.127zM493.952 294.91c0 1.3-.959 2.365-2.133 2.365H248.573c-1.173 0-2.133-1.064-2.133-2.365v-8.464c0-1.302.96-2.366 2.133-2.366H491.82c1.174 0 2.133 1.064 2.133 2.366v8.464z",
    transform: "translate(.5) translate(0 75)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterPlaceholder);
export default __webpack_public_path__ + "static/media/center_placeholder.d2c60c8ce91a2c87be32e4f2af3bed7d.svg";
export { ForwardRef as ReactComponent };